<template>
  <article class="card">
    <header class="card__header">
      <slot
        v-if="slots.header"
        name="header"
      ></slot>
      <TitlePage
        v-else
        :title="props$$.title"
      />
    </header>
    <slot name="before__body"></slot>
    <section class="card__body p-AJ">
      <slot name="body"></slot>
    </section>
    <slot name="after__body"></slot>
  </article>
</template>

<script setup>
// #region VUE
import {
  useSlots,
} from 'vue';
// #endregion

// #region STTEDRA
import {
// DataView,
// matchModeEnum,
// operatorEnum,
// useDeleteNulls,
// useDownload,
// useNormalizer,
// useToast,
// Form,
// useDev,
// useImmer,
} from '@sttedra_ui/framework';
// #endregion

// #region COMPONENTS COMPOSABLES
import TitlePage from '@/components/title-page/TitlePage.vue';
// #endregion

// #region Props, Emits
const props$$ = defineProps({
  title: {
    type: String,
    default: '',
  },
});
// #endregion

// #region Params, Ref, Reactives, Computed
const slots = useSlots();
// #endregion
</script>

<style lang="scss" scoped>
@use '@/styles/vars' as *;
@use '@/styles/breakpoints' as *;

.card{
  background: transparent !important;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  gap: 1.2rem;
  height: -webkit-fit-content;
  height: -moz-fit-content;
  height: fit-content;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;

  border: 0;
  margin-bottom: 6rem;

  @media print {
    margin-bottom: 1rem;
  }

  @include media("<=phone") {
    width: 100%;
  }

  &__body{
    background-color: $pv__color--white;
    border-left-width: 5px;
    border-radius: $brand__boxspace--medium;
    border: 1px solid var(--primary-color);
    width: fit-content;
    margin: auto;

    @include media("<=phone") {
      min-width: 250px;
      padding: ($brand__boxspace--medium * 2) ($brand__boxspace--medium);
    }
    @include media(">phone") {
      padding: ($brand__boxspace--medium * 2) ($brand__boxspace--medium * 2);
    }
    @include media(">phone", "<=tablet") {
      padding: ($brand__boxspace--medium * 2) ($brand__boxspace--medium * 4);
    }
    @include media(">tablet", "<=desktop") {
      padding: ($brand__boxspace--medium * 2) ($brand__boxspace--medium * 4);
    }
    @include media(">desktop") {
      padding: ($brand__boxspace--medium * 2) ($brand__boxspace--medium * 4);
    }

    @media print {
      padding: 0.5rem 1rem !important;
    }
  }
}
</style>
